/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_DismissedInputs */

const en_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip dismissed`)
};

const de_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipp geschlossen`)
};

const fr_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conseil ignoré`)
};

const es_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consejo descartado`)
};

const it_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerimento ignorato`)
};

const nl_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip gesloten`)
};

const pl_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wskazówka odrzucona`)
};

const fi_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinkki ohitettu`)
};

const da_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip afvist`)
};

const sv_ats_tip_dismissed = /** @type {(inputs: Ats_Tip_DismissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips stängt`)
};

/**
* | output |
* | --- |
* | "Tip dismissed" |
*
* @param {Ats_Tip_DismissedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_dismissed = /** @type {((inputs?: Ats_Tip_DismissedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_DismissedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_dismissed(inputs)
	if (locale === "fr") return fr_ats_tip_dismissed(inputs)
	if (locale === "es") return es_ats_tip_dismissed(inputs)
	if (locale === "it") return it_ats_tip_dismissed(inputs)
	if (locale === "nl") return nl_ats_tip_dismissed(inputs)
	if (locale === "pl") return pl_ats_tip_dismissed(inputs)
	if (locale === "fi") return fi_ats_tip_dismissed(inputs)
	if (locale === "da") return da_ats_tip_dismissed(inputs)
	if (locale === "sv") return sv_ats_tip_dismissed(inputs)
	return en_ats_tip_dismissed(inputs)
});